define(["dojo/i18n", "/home/semaphore/scramble4/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"scramble/widgets/modal/nls/zh-tw/alert"
,"scramble/widgets/modal/nls/zh/alert"
,"scramble/widgets/modal/nls/ja/alert"
,"scramble/widgets/modal/nls/fr/alert"
,"scramble/widgets/modal/nls/de/alert"
,"scramble/widgets/modal/nls/ko/alert"
,"scramble/widgets/modal/nls/it/alert"
,"scramble/widgets/modal/nls/cs/alert"
,"scramble/widgets/modal/nls/tr/alert"
,"scramble/widgets/modal/nls/pl/alert"
,"scramble/widgets/modal/nls/fi/alert"
,"scramble/widgets/modal/nls/hu/alert"
,"scramble/widgets/modal/nls/sk/alert"
,"scramble/widgets/modal/nls/nb/alert"
,"scramble/widgets/modal/nls/es/alert"
,"scramble/widgets/modal/nls/nl/alert"
,"scramble/widgets/modal/nls/pt/alert"
,"scramble/widgets/modal/nls/ru/alert"
,"scramble/widgets/modal/nls/sv/alert"
,"/home/semaphore/scramble4/src/scramble/widgets/modal/nls/alert.js?absMid=scramble/widgets/modal/nls/alert"
], function(loader, runner) {
   return runner(loader, "scramble/widgets/modal/nls/alert", __webpack_require__.dj.c(), false);
});